import React from "react";
import { SxStyleProp } from "theme-ui";
import { Box } from "../Box";

export interface SVGProps {
  sx?: SxStyleProp;
  xmlns?: string;
  viewBox?: string;
  fill?: string;
  [key: string]: any;
}

export interface Props extends SVGProps {
  size?: number | string;
}

const SVG: React.FunctionComponent<Props> = React.forwardRef(
  ({ size = 24, ...props }, ref) => (
    <Box
      ref={ref}
      as="svg"
      xmlns="http://www.w3.org/2000/svg"
      minWidth={size}
      minHeight={size}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentcolor"
      {...props}
    />
  ),
);

export default SVG;
